<style scoped>
html *:not(.v-icon):not(i.material-icons):not(span.material-icons) {
  font-family: "DM Sans", "sans-serif";
}
@media (max-width: 768px) {
  div.toast-outer.toast-position-bottom {
    max-width: 75% !important;
  }
}
</style>

<template>
  <div id="app">
    <template v-if="!isLoading">
      <router-view />
    </template>
    <StartPage v-if="isLoading" />
  </div>
</template>

<script>
import {
  logEvent,
  getAppCustomEnv,
  growthbookUtil,
  getAppFeatureProp,
  ConfigMixin,
} from "@sleek/customer-common-acquisition";

import Cookies from "js-cookie";

import { mapActions } from "vuex";

import { memoizedCountryCodeFromDomain } from "@/utils/get-country-code-from-domain";
import StartPage from "@/modules/sleek-onboarding/shared/pages/start-page/StartPage.vue";

import { i18nCookieName, loadLanguageAsync } from "@/plugins/i18n";
import onboardingFlowModule from "./store/modules/onboarding-flow-module";
import onboardingFlowModuleUK from "./store/modules/onboarding-flow-module-uk";

export default {
  components: {
    StartPage,
  },
  mixins: [ConfigMixin],
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    ...mapActions("authModule", ["loadSSOProfile"]),
    async initAnalytics() {
      const appCustomEnv = await getAppCustomEnv();
      const growthBookInstance = await growthbookUtil.init(
        appCustomEnv.VUE_GROWTHBOOK_SDK_KEY,
        appCustomEnv.VUE_GROWTHBOOK_HOST,
        appCustomEnv.VUE_GROWTHBOOK_FALLBACK_URL,
        false
      );
      logEvent.init(growthBookInstance);
    },
    async getLocaleBasedOnCountry() {
      const countryCode = await memoizedCountryCodeFromDomain();
      const params = new URLSearchParams(window.location.search);
      const langKey = params.get("lang");

      switch (countryCode.toString()) {
        case "HKG":
        case "HK":
          return langKey == "HK" || langKey == "hk"
            ? "zh"
            : Cookies.get(i18nCookieName) !== "zh" &&
              Cookies.get(i18nCookieName) !== "en"
            ? "en"
            : Cookies.get(i18nCookieName);
        case "AUS":
        case "AU":
          return "au";
        case "UK":
        case "GBR":
        case "GB":
          return "uk";
        case "SGP":
        case "SG":
          return "sg";
        default:
          // SG or UK
          return "en";
      }
    },
    async getStoreBasedOnCountry() {
      const countryCode = await memoizedCountryCodeFromDomain();

      switch (countryCode) {
        case "GBR":
        case "UK":
          this.$store.registerModule(
            "onboardingFlowModule",
            this.$store.state["onboardingFlowModule"]
              ? {
                  ...onboardingFlowModuleUK,
                  state: this.$store.state["onboardingFlowModule"],
                }
              : onboardingFlowModuleUK
          );
          break;
        default:
          // SG
          this.$store.registerModule(
            "onboardingFlowModule",
            this.$store.state["onboardingFlowModule"]
              ? {
                  ...onboardingFlowModule,
                  state: this.$store.state["onboardingFlowModule"],
                }
              : onboardingFlowModule
          );
          break;
      }
    },
  },
  async created() {
    try {
      console.log("Loading Store Vuex");
      await this.getStoreBasedOnCountry();
      console.log(
        "Loaded Store Vuex: ",
        Object.keys(this.$store._modulesNamespaceMap).includes(
          "onboardingFlowModule"
        )
      );
      const localeBasedOnCountry = await this.getLocaleBasedOnCountry();
      await Promise.all([
        loadLanguageAsync(localeBasedOnCountry),
        this.initAnalytics(),
        this.$store.dispatch("configModule/GET_PLATFORM_CONFIG", {
          root: true,
        }),
      ]);
      this.$i18n.locale = localeBasedOnCountry;

      const auth0Config = getAppFeatureProp(
        this.platformConfig.cmsAppFeatures,
        "auth0"
      );
      if (auth0Config.enabled) {
        const response = await this.loadSSOProfile();
        if (response) {
          this.$store.commit("userModule/setUser", response, { root: true });

          // Why ?
          this.$store.commit("configModule/setIsLogin", true, { root: true });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }

    // add blur so that input with type is number wont try to adjust value
    document.addEventListener("wheel", function () {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });
  },
  beforeDestroy() {
    this.$store.unregisterModule("onboardingFlowModule");
  },
};
</script>
